<template>
  <main class="discover">
    <transition name="context">
      <context-slot v-show="!contextSlotHidden">
        <font-options />
      </context-slot>
    </transition>
    <font-preview />
    <transition name="controls">
      <font-controls v-show="fontPreviewHasInput" />
    </transition>
  </main>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import ContextSlot from '@/components/ContextSlot';
  import FontOptions from './components/FontOptions';
  import FontPreview from './components/FontPreview';
  import FontControls from './components/FontControls';

  export default {
    name: 'discover',
    components: {
      'context-slot': ContextSlot,
      'font-options': FontOptions,
      'font-preview': FontPreview,
      'font-controls': FontControls
    },
    computed: {
      ...mapState('ui', [
        'contextSlotHidden',
        'fontPreviewHasInput'
      ])
    },
    methods: {
      ...mapActions('ui', [
        'setFontPreviewState'
      ]),
      ...mapActions('font', [
        'setNewFont'
      ]),
    },
    mounted() {
      this.setNewFont();
    },
    beforeRouteLeave (to, from, next) {
      this.setFontPreviewState(false);
      next();
    }
}
</script>

<style lang="scss" scoped>
  .discover {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .context-enter-active, .context-leave-active {
    transition: all 500ms ease-in-out;
  }
  
  .context-enter, .context-leave-to {
    transform: translateY(-16rem);
  }

  .controls-enter-active, .controls-leave-active {
    transition: all 500ms ease-in-out;
  }
  
  .controls-enter, .controls-leave-to {
    transform: translateY(calc(10rem + 5vh));
    opacity: 0;
  }
</style>
